<template>
    <div :class="classList" :style="styleList" v-html="message">
    </div>
    
</template>
<script>
export default {
    props: {
        message:{
            type: String,
            default: ""
        },
        classList: {
            type: String,
            default: ""
        },
        styleList: {
            type: Object,
        }
    }
    
}
</script>
<style lang="scss" scoped>

</style>